export const UPSERT_LIFE_POLICY = `
mutation upsertLifePolicy($key: String!) {
  upsertLifePolicy(key: $key){
    __typename
    ... on SyncBoolean{
      status
    }
    ... on ResultError{
      status_code
      message
    }
  }
}
`;
